function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useState } from "react";
import FlexItemOrg from "../../../FlexItemOrg";
import { Wrapper } from "./BottomBarOrg.styled";
function BottomBarOrg(_ref) {
  var children = _ref.children,
    isSticky = _ref.isSticky,
    isHeaderSticky = _ref.isHeaderSticky,
    headerWrapperRef = _ref.headerWrapperRef,
    headerBarRef = _ref.headerBarRef;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    headerMainHeight = _useState2[0],
    setHeaderMainHeight = _useState2[1];
  var getHeaderMainHeight = useCallback(function () {
    var headerWrapper = headerWrapperRef.current;
    var headerWrapperHeight = headerWrapper ? headerWrapper.offsetHeight : 0;
    var headerBar = headerBarRef.current;
    var headerBarHeight = headerBar ? headerBar.offsetHeight : 0;
    var mainHeight = headerWrapperHeight - headerBarHeight;
    setHeaderMainHeight(mainHeight);
  }, [headerWrapperRef]);
  useEffect(function () {
    getHeaderMainHeight();
  }, [headerWrapperRef, getHeaderMainHeight]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    $isSticky: isSticky,
    $isHeaderSticky: isHeaderSticky,
    $headerMainHeight: headerMainHeight
  }, /*#__PURE__*/React.createElement(FlexItemOrg, {
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1
  }, children));
}
export default BottomBarOrg;